import React from 'react';
import * as rmd from 'material-ui'
import CopyToClipboard from 'react-copy-to-clipboard';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Dropzone from 'react-dropzone';

const FastImagesPicker = ({images, onPick, pickedKey, upload, onDrop, uploadPreview, uploading, gridSize = 5, itemHeight}) => {
    return (
        <div className="rlz-fast-image-picker">
            {upload &&  <rmd.Paper zDepth={1} key='dropzone' className={`rlz-fast-image-picker__uploaded-image rlz-fast-image-picker__image-input rlz-fast-image-picker__uploaded-image rlz-fast-image-picker__uploaded-image__grid-size-${gridSize}`}>
                <Dropzone onDrop={onDrop}  style={{height: itemHeight}} >
                    <div className="rlz-fast-image-picker__image-preview" style={{height: itemHeight}} >
                        <ContentAdd />
                        <img src={uploadPreview} />
                    </div>
                </Dropzone>
                {uploading && <span className="rlz-fast-image-picker__uploading-indicator">
                    <rmd.CircularProgress size={80} thickness={5}/>
                </span>}
            </rmd.Paper>
            }
            {images.map((img, i) => {
                
                const previewUrl = img.thumbs.find(t => t.size == 'preview').url;

                return (
                    <rmd.Paper zDepth={pickedKey == img.key ? 4 : 1} key={i} className={`rlz-fast-image-picker__uploaded-image rlz-fast-image-picker__uploaded-image__grid-size-${gridSize}`}>
                        <CopyToClipboard text={img.url} onCopy={(value) => {onPick(value, img)}}>
                            <div className="rlz-fast-image-picker__uploaded-image-preview-wrapper"  style={{height: itemHeight}} >
                                <div>
                                    <img  className="rlz-fast-image-picker__uploaded-image-preview" src={previewUrl} />
                                </div>
                            </div>
                        </CopyToClipboard>
                    </rmd.Paper>
                )
            })}
        </div>
    )
};

export default FastImagesPicker;


/** WEBPACK FOOTER **
 ** ../src/dash/front/components/FastImagesPicker.js
 **/